import { get } from '@tovala/browser-apis-combinedapi'

export interface MenuProductUserRating {
  id: string
  stars: number | null
  comment: string
  chips: string[]
  created: string
}

export interface MenuProductRating {
  menuProductID: string
  // mealID will be null if/when we use this for extras/listings
  mealID: number | null
  userRating: MenuProductUserRating | null
}

export interface GetMenuProductRatingsRequest {
  menuID: string
  userID: number
}

export interface GetMenuProductRatingsResponse {
  schemaVersion: string
  menuProducts: MenuProductRating[]
}

export const ENDPOINTS = {
  GET_MENU_PRODUCT_RATINGS: ({
    menuID,
    userID,
  }: Pick<GetMenuProductRatingsRequest, 'menuID' | 'userID'>) => ({
    path: `/users/${userID}/menus/${menuID}/menuProductRatings`,
    version: 'v2' as const,
  }),
}

export async function getMenuProductRatings({
  menuID,
  userID,
}: GetMenuProductRatingsRequest) {
  return get<GetMenuProductRatingsResponse>(
    ENDPOINTS.GET_MENU_PRODUCT_RATINGS({ menuID, userID }),
  )
}
